<template>
	<div id="municipalInfoDetail" data-role="page">
		<!-- content -->
		<div class="municipalInfoDetail-content" data-position="fixed">
			<div class="detailWrap" v-if="detailData.content">
                <div class="detail-h">
                    <template v-if="detailData.type == 'municipal'">
                        <span class="cgy-tag">{{ detailData.content.MessageType }}</span>
                    </template>
                    <template v-else-if="detailData.type == 'village'">
                        <template v-if="isGetProfileInfoSuccess">
                            <span v-if="villageIdx < 3" class="cgy-tag" v-for="(villageVal,villageIdx) in detailData.content.VillageName" :key="villageIdx">{{ villageVal }}</span>
                            <span v-if="detailData.content.VillageName.length > 3" class="cgy-tag">＋{{ detailData.content.VillageName.length - 3 }}</span>
                        </template>
                    </template>
					<h3 :class="{'LargSize':fz_larg}">{{ detailData.content.MessageTitle }}</h3>
					<span class="article_date" :class="{'LargSize':fz_larg}">{{ dateFormat(detailData.content.MessageDate,'YYYY/MM/DD') }}</span>
				</div>
				<!-- 文章內容 -->
                <div class="detail-c">
                    <div class="txtContent" :class="{'LargSize':fz_larg}">
						<p v-html="contentTransform(detailData.content.MessageContent)"></p>
					</div>
				</div>
				<!-- /文章內容 -->
                <!-- 附檔 -->
                <div class="detail-a" v-if="detailData.content.Files && detailData.content.Files.length>0">
                    <div class="attachTitle">檢視附加檔案</div>
                    <div class="attachFileWrap" :class="{'LargSize':fz_larg}">
						<div v-for="(files, fileIdx) in detailData.content.Files" :key="fileIdx" class="attachFile" @click="OpenFile(files.FileLink, files.FileName)">
                             <i class="icon-clip"></i>
                            <span>{{ files.FileName }}</span>
                        </div>
					</div>
				</div>
                 <!-- /附檔 -->
			</div>
		</div>
		<!-- /content -->
        <!-- footer -->
        <div class="qk-functionBar active" v-if="Authority">
            <div :class="[Authority? 'qk-functionBar-wrap-col4':'qk-functionBar-wrap-col1']">
                <div v-on:click="Share(detailData.content.MessageId,detailData.content.MessageTitle)"><span><i class="icon-share"></i>分享</span></div>
                <div v-on:click="ChanegSize"><span><i class="icon-letterA"></i>大小</span></div>
            </div>               
        </div>
        <!-- /footer -->
	</div>  
</template>

<script lang="js">
export default {
    data () {
        return {
            detailData: {
                type: '',
                content: ''
            },
            Authority: false,   
            fz_larg: false,
            toastControl:{
                show: false,
                full: false,
                content: '',
                showTime: 1000
            },
            scrollPrevioustTicks:0,
            comList: [],
            isGetProfileInfoSuccess: true
        }
    },
    mounted(){
        let vobj = this;
        this.CheckAuthority();
        const type = this.$route.params.type;
        const id = this.$route.params.id;
        window.addEventListener('scroll', this.handleScroll);
        this.GetProfileInfo().then((r)=>{
            this.Authority= true
            this.isGetProfileInfoSuccess = true
            let isNtpc = this.comList.some((v)=>{
                if(v.municipalType == 'Ntpc'){
                    return true
                }
            })
            var villageList = this.comList.map((v)=>{
                if(v.villageId != null){
                    return v.villageId
                }
            })
            villageList = Array.from(new Set(villageList))
            console.log(villageList)
            if(type == 'municipal' && isNtpc){
                this.GetMunicipalList('Ntpc').then((r)=>{
                    this.detailData.type = 'municipal'
                    let filterData = r.filter((v,i)=>{
                        if(v.MessageId == id){
                            return v
                        }
                    })
                    this.detailData.content = (filterData && filterData.length > 0) ? filterData[0] : null
                })
            }
            if(type == 'village'){
                this.GetVillageList(villageList).then((r)=>{
                    this.detailData.type = 'village'
                    r = r.map((v)=>{
                        v.VillageName = v.VillageName.filter((village)=>{
                            return village != null
                        })
                        v.VillageName = Array.from(new Set(v.VillageName)) //篩選重複項
                        return v
                    })

                    let filterData = r.filter((v,i)=>{
                        if(v.MessageId == id){
                            return v
                        }
                    })
                    var showData = null
                    if(filterData && filterData.length > 0){
                        showData = filterData.map((v)=>{
                            v.VillageName = v.VillageName.filter((village)=>{
                                return village != null
                            })
                            v.VillageName = Array.from(new Set(v.VillageName)) //篩選重複項
                            return v
                        })
                    }
                    this.detailData.content = (showData && showData.length > 0) ? showData[0] : null
                })
            }
        }).catch((e)=>{
            this.Authority= false
            this.isGetProfileInfoSuccess = false
            const type = this.$route.params.type;
            const id = this.$route.params.id;
            if(type == 'municipal'){
                this.GetMunicipalList('Ntpc').then((r)=>{
                    this.detailData.type = 'municipal'
                    let filterData = r.filter((v,i)=>{
                        if(v.MessageId == id){
                            return v
                        }
                    })
                    this.detailData.content = (filterData && filterData.length > 0) ? filterData[0] : null
                })
            }
            if(type == 'village'){
                this.GetVillageList([]).then((r)=>{
                    this.detailData.type = 'village'
                    let filterData = r.filter((v,i)=>{
                        if(v.MessageId == id){
                            return v
                        }
                    })
                    this.detailData.content = (filterData && filterData.length > 0) ? filterData[0] : null
                })
            }
        })
        
    },
    methods:{
        //底部功能表示窗滾動事件
        handleScroll () {
            let scrollBottom = $(document).height() - $(window).height() - $(window).scrollTop();

            if(this.scrollPrevioustTicks<window.scrollY){
                //向下滑動
                $('.qk-functionBar').removeClass('active')
                if(scrollBottom == 0){$('.qk-functionBar').addClass('active')} 
            }else if(this.scrollPrevioustTicks>window.scrollY){
                //向上滑動
                $('.qk-functionBar').addClass('active')
            }
            this.scrollPrevioustTicks = window.scrollY;
        },
        //取得市政訊息列表
        GetMunicipalList(municipalType){
            let vobj=this;
            return new Promise((resolve, reject)=>{
                this.axios.get(`${process.env.SmartlifeCoreApi}/MunicipalInformation/${municipalType}`,{
                    // headers:{Authorization: Token},
                }).then((response) => {
                    if(response.status == 200){
                        resolve(response.data.Data)
                    }else{
                        Promise.reject('status 不是200')
                    }
                }).catch((err) => {
                    console.log(err)
                    reject()
                })
            })
        },
        //取得新訊列表
        GetVillageList(villageId){
            let vobj=this;
            return new Promise((resolve, reject)=>{
                this.axios.get(`${process.env.SmartlifeCoreApi}/MunicipalInformation/Village/`,{
                    // headers:{Authorization: Token},
                    params: {
                        villageIds: villageId
                    }
                }).then((response) => {
                    if(response.status == 200){
                        resolve(response.data.Data)
                    }else{
                        Promise.reject('status 不是200')
                    }
                }).catch((err) => {
                    console.log(err)
                    reject()
                })
            })
        },
        //取得使用者社區資料
        GetProfileInfo(){
            let vobj=this;
            return new Promise((resolve, reject)=>{
                if(!Token || Token=='undefined' || Token=='null'){ 
                    return reject()
                }
                this.axios.get(`${process.env.SmartlifeCoreApi}/Profile/GetProfileInfo/`,{
                    headers:{KingnetAuth: 'CommunityUser ' + decodeURIComponent(Token)}
                }).then((response) => {
                    console.log(response)
                    if(response.data && response.data.Data && response.data.Data.plist && response.data.Data.plist.length>0){
                        this.comList = response.data.Data.plist
                        resolve(this.comList)
                    }else{
                        reject()
                    }
                }).catch((err) => {
                    console.log(err)
                    reject()
                })
            })
        },
        //檢查權限
        CheckAuthority(){
            if(localStorage.getItem("token")=='' || localStorage.getItem("token") == null){
                this.Authority= false
            }else{
                this.Authority= true
            }
        },
        dateFormat(date, format){
            if(date){
                return this.$root.dateFormat(date, format)
            }else{
                return ''
            }
        },
        contentTransform(content){
            let returnObj = content
            if(returnObj){
                return returnObj.replace(/\n/g,'<br>')
            }else{
                return returnObj
            }
            
        },
        //文字大小變化
        ChanegSize(){
            this.fz_larg ? this.fz_larg=false : this.fz_larg=true;
        },
        //分享按鈕
        Share(id,title){
            const type = this.$route.params.type;
            let trimTitle = title.length > 20 ? (title.substring(0,19) + '...') : title
            document.location.href='#/municipalInfoDetail/'+type+'/'+id+"/@@@"+ encodeURIComponent(trimTitle)+"?mode=share"
        },
        //打開檔案
        OpenFile(link, title){
            window.open(`https://inapp.kingnetsmart.com.tw/ad.html?page=linkRule&params1=7&params2=${encodeURIComponent(link)}&title=${encodeURIComponent(title)}&referrer=${encodeURIComponent(location.href)}`,'_blank')
        },
    },
}
</script>


// WEBPACK FOOTER //
// src/components/municipalInfoDetail.vue